const INFO_POPUP_DISPLAYED_KEY = 'riseup.wasPredictedIncomeInfoPopupDisplayed'; // It's for predicted VARIABLE income
export default {
  INFO_POPUP_DISPLAYED_KEY,
};
